import axios from 'axios';
import config from 'config';
import router from 'router';
import store from 'store';
import { checkTokenTimestamps } from 'utils/tokenService';

export const HTTP = axios.create({
  baseURL: config.api,
  headers: {
    'Content-Type': 'application/json',
  },
});

HTTP.interceptors.request.use((config) => {
  const map = [
    '/auth/extend-token',
    '/mdlive/extend-token',
    '/answers/extend-token',
  ];

  if ( config.headers.common.Authorization && !map.includes(config.url) ) {
    checkTokenTimestamps();
  }
  
  return config;
}, (error) => Promise.reject(error));

HTTP.interceptors.response.use((response) =>
  response, (error) => {
  console.error('Interceptor error', error);


  if ( error.response.status === 500 ) {
    if ( error.response.config.url.split('/').pop() !== 'password-change' ) {
      store.dispatch('app/setErrorMessage', 'We\'re having trouble connecting<br class="hide-below-medium"> with our network right now');

      router.push({
        name: 'error',
      });
      // TODO: Get the error codes straight because this is rubbish
      // Error types
      // NotAuthorizedException
      // LimitExceededException
    } else if ( error.response.data.error_type === 'NotAuthorizedException' ) {
      error.response.data.errors[0].message = 'There seems to be an authentication issue. Is your current password correct?';
    } else if ( error.response.data.error_type === 'LimitExceededException' ) {
      error.response.data.errors[0].message = 'Oh no, it seems you\'ve tried to do that too many times! Wait a while and try again.';
    }
  }

  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./client/api/http.js